import type { PanoramaClientForComponent } from '@wix/yoshi-flow-editor/panorama';

export type ErrorReportingClient = Pick<
  PanoramaClientForComponent,
  'errorMonitor'
>;
type ErrorData = NonNullable<
  Parameters<ReturnType<ErrorReportingClient['errorMonitor']>['reportError']>[1]
>;

export const reportError = (
  panoramaClient: ErrorReportingClient | undefined,
  error: unknown,
  tags?: ErrorData['tags'],
) => {
  console.error(error); // eslint-disable-line no-console

  if (error instanceof Error) {
    panoramaClient?.errorMonitor().reportError(error, { tags });
  } else if (typeof error === 'string') {
    panoramaClient?.errorMonitor().reportError(new Error(error), { tags });
  }
};
